import React from 'react';
import { NumberString, PriceString } from '@fourthwall/components';
export const formatChartValue = (value, type) => {
    if (type === 'money') {
        return React.createElement(PriceString, { value: value });
    }
    if (type === 'number') {
        return React.createElement(NumberString, { value: value });
    }
    if (type === 'date')
        return '';
    return value;
};
